/**
 * CONSAI — Header (dark, sticky, AI Search Bar)
 */
import React from 'react';
import SearchBar from './SearchBar';

const Header = ({ title }) => {
  return (
    <header
      className="sticky top-0 z-30 border-b border-white/10"
      style={{
        background: 'rgba(10,10,11,0.78)',
        backdropFilter: 'saturate(140%) blur(14px)',
        WebkitBackdropFilter: 'saturate(140%) blur(14px)',
      }}
    >
      <div className="px-4 lg:px-6 py-3">
        <div className="flex items-center gap-4">
          {title && (
            <h1 className="hidden md:block text-lg font-semibold tracking-tight text-white whitespace-nowrap">
              {title}
            </h1>
          )}
          <div className="flex-1">
            <SearchBar />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
